// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@/modules/common/components/Paper';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import ButtonMenu from '@/modules/common/components/ButtonMenu';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import Pagination from '@/modules/common/components/Pagination';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import DialogChangePassword from '@/modules/common/components/DialogChangePassword';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import Table from './Table';
import ContextMenu from './ContextMenu';
import DialogDelete from './DialogDelete';
import DialogAddAdmin from '../DialogAddAdmin';
import DialogAddClient from '../DialogAddClient';
import DialogAddAffiliate from '../DialogAddAffiliate';
import '../../styles/Users.scss';

const breadcrumbs = [
    {name: 'Пользователи'},
];

let abortController;

const Users = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [openDialogAddAdmin, setOpenDialogAddAdmin] = useState(false);
    const [openDialogAddClient, setOpenDialogAddClient] = useState(false);
    const [openDialogAddAffiliate, setOpenDialogAddAffiliate] = useState(false);
    const [openDialogChangePassword, setOpenDialogChangePassword] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [positionContextMenu, setPositionContextMenu] = useState({left: null, top: null});

    const { enqueueSnackbar } = useSnackbar();

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/users/?${props.router.urlSearchParams.toString()}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const closeContextMenu = () => {
        setPositionContextMenu({left: null, top: null});
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let page = parseInt(props.router.urlSearchParams.get('page'));
        if (isNaN(page)) {
            page = 1;
        }
        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);
        fetch();
    }, [props.history.location.search]);

    /******************************************************************************************************************/

    const handleClickAddAdmin = (popupState) => () => {
        popupState.close();
        setOpenDialogAddAdmin(true);
    };

    const handleClickAddAffiliate = (popupState) => () => {
        popupState.close();
        setOpenDialogAddAffiliate(true);
    };

    const handleClickAddClient = (popupState) => () => {
        popupState.close();
        setOpenDialogAddClient(true);
    };

    /******************************************************************************************************************/

    const handleContextMenu = (user) => (event) => {
        event.preventDefault();
        setSelectedUser(user);
        setPositionContextMenu({left: event.clientX, top: event.clientY});
    };

    const handleClickChangePassword = () => {
        closeContextMenu();
        setOpenDialogChangePassword(true);
    };

    const handleClickDelete = () => {
        closeContextMenu();
        setOpenDialogDelete(true);
    };

    const handleCloseContextMenu = () => {
        closeContextMenu();
        setSelectedUser(null);
    };

    /******************************************************************************************************************/

    const handleAddAdminOk = () => {
        setOpenDialogAddAdmin(false);
        props.router.reload();
        enqueueSnackbar('Администратор добавлен', {variant: 'success'});
    };

    const handleAddAffiliateOk = () => {
        setOpenDialogAddAffiliate(false);
        props.router.reload();
        enqueueSnackbar('Партнер добавлен', {variant: 'success'});
    };

    const handleAddClientOk = () => {
        setOpenDialogAddClient(false);
        props.router.reload();
        enqueueSnackbar('Клиент добавлен', {variant: 'success'});
    };

    const handleDeleteOk = () => {
        setOpenDialogDelete(false);
        setSelectedUser(null);
        props.router.reload();
        enqueueSnackbar('Пользователь удален', {variant: 'success'});
    };

    /******************************************************************************************************************/

    // noinspection JSUnresolvedVariable
    return (
        <Content id="users">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><Paper>
                {(!loading)
                    ? <>
                        {(data && data.results)
                            ? <>
                                <ContentBodyTop left={
                                    <PopupState variant="popover">
                                        {(popupState) => (
                                            <>
                                                <ButtonMenu buttonProps={{...bindTrigger(popupState)}}
                                                            buttonContent="Добавить"
                                                            menuProps={{...bindMenu(popupState)}}
                                                >
                                                    <MenuItem onClick={handleClickAddAdmin(popupState)}>
                                                        Администратора
                                                    </MenuItem>
                                                    <MenuItem onClick={handleClickAddAffiliate(popupState)}>
                                                        Партнера
                                                    </MenuItem>
                                                    <MenuItem onClick={handleClickAddClient(popupState)}>
                                                        Клиента
                                                    </MenuItem>
                                                </ButtonMenu>
                                            </>
                                        )}
                                    </PopupState>
                                }/>
                                <DialogAddAdmin open={openDialogAddAdmin} setOpen={setOpenDialogAddAdmin}
                                                onOk={handleAddAdminOk}
                                />
                                <DialogAddAffiliate open={openDialogAddAffiliate}
                                                    setOpen={setOpenDialogAddAffiliate}
                                                    onOk={handleAddAffiliateOk}
                                />
                                <DialogAddClient open={openDialogAddClient}
                                                 setOpen={setOpenDialogAddClient}
                                                 onOk={handleAddClientOk}
                                />
                                {(data.results.length > 0)
                                    ? <>
                                        <Table users={data.results} selectedUser={selectedUser}
                                               onContextMenu={handleContextMenu}
                                        />
                                        <ContextMenu position={positionContextMenu}
                                                     onClickChangePassword={handleClickChangePassword}
                                                     onClickDelete={handleClickDelete}
                                                     onClose={handleCloseContextMenu}
                                        />
                                        <DialogChangePassword username={(selectedUser) ? selectedUser.username : ''}
                                                              setSelected={setSelectedUser}
                                                              open={openDialogChangePassword}
                                                              setOpen={setOpenDialogChangePassword}
                                        />
                                        <DialogDelete selectedUser={selectedUser} setSelectedUser={setSelectedUser}
                                                      open={openDialogDelete} setOpen={setOpenDialogDelete}
                                                      onOk={handleDeleteOk}
                                        />
                                        <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                    </>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </Paper></ContentBody>
        </Content>
    );
};

let Component = Users;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;
